import type { Event } from "../types/event";

export const mockEvents: Event[] = [
    {
        id: "demi-finales-ligue-2-zeros-2026",
        slug: "demi-finales-ligue-2-zeros-2026",
        title: "Demi-finales de la Ligue des 2 Zéros : dernière marche avant la finale",
        summary:
            "Les demi-finales de la Ligue des 2 Zéros annoncent une grande journée de football, de buts, de score décisif et de qualification pour la finale de la ligue.",
        image: "/images/events/demi-finales.jpg",
        dateLabel: "Samedi 6 juin 2026",
        timeLabel: "À partir de 11h00",
        location: "158 Rue Neuwies, 4635 Oberkorn Differdange",
        featured: true,
        
    description:
        "La Ligue des 2 Zéros du Luxembourg et des 3 Frontières entre dans sa phase finale avec une journée décisive sur la pelouse d’Oberkorn Differdange. Après une saison marquée par plus de 40 matchs, de nombreux buts, des victoires importantes, des défaites difficiles, des scores serrés et plusieurs matchs disputés jusqu’à la dernière minute, les meilleures équipes issues des poules se retrouvent pour jouer une place en finale de la ligue. Cette première édition réunit des clubs, des entraîneurs, des joueurs, des buteurs, des arbitres, des familles et des supporters autour d’un championnat amateur multiculturel placé sous le signe du fair-play, de l’intégration et du vivre-ensemble. Comme dans les grandes soirées de coupe, chaque mi-temps peut faire basculer le match, chaque coup franc peut devenir décisif et chaque équipe peut croire à l’exploit.",

    program: [
        {
            time: "11h00",
            title: "Match de gala : Les amis de Camel vs Le Reste du Monde",
            description:
                "Un match amical et symbolique pour ouvrir la journée dans une ambiance festive, avec des invités, des anciens joueurs, des coéquipiers de la ligue et des représentants de plusieurs communautés.",
        },
        {
            time: "14h00",
            title: "Demi-finale 1 : Thionville vs Camerlux",
            description:
                "Une première demi-finale très attendue entre deux adversaires ambitieux. Thionville et Camerlux visent la qualification pour la grande finale, avec l’objectif de marquer les buts décisifs et d’éviter la défaite.",
        },
        {
            time: "16h00",
            title: "Demi-finale 2 : Cap-Vert vs Sénégal",
            description:
                "Un deuxième choc sportif entre deux équipes solides. Portés par leurs supporters, Cap-Vert et Sénégal veulent rejoindre la finale de la ligue et se rapprocher du trophée de champion.",
        },
    ],
},


];
